// src/components/Loader.js
import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from '../animations/loader.json'

const Loading = ({ className = "progress-loader", loop = true }) => {
  return (
    <Lottie
      animationData={loaderAnimation}
      loop={loop}
      className={className}
    />
  );
};

export default Loading;
